const strutCorsi = () => {
	const strutturaID = document.getElementById('vue-strutCorsi').dataset.strutturaid;
	const mondoStruttura = document.getElementById('vue-strutCorsi').dataset.mondo;
	const corporate_url = document.getElementById('vue-strutCorsi').dataset.corporate;
	const endpoint_academy = corporate_url + '/wp-json/api/v1/korian_academy?struttura=' + strutturaID + '&mondo=' + mondoStruttura;

	if (document.getElementById('vue-strutCorsi')) {
		var app = new Vue({
			el: '#vue-strutCorsi',
			data() {
				return {
					strCorsi: [],
					loading: true,
					headers: new Headers(),
				}
			},
			mounted() {
				this.checkHeaders();
				fetch(endpoint_academy)
					.then(res => res.json())
					.then(data => {
						if (data.length > 3) {
							let removeFirstThree = data.splice(0, 3);
							this.strCorsi = removeFirstThree;
						} else {
							this.strCorsi = data;
						}
					})
				this.loading = false;
			},
			methods: {
				checkHeaders() {
					const basic_username = document.getElementById('vue-strutStampa')?.dataset.username;
					const basic_pwd = document.getElementById('vue-strutStampa')?.dataset.pwd;

					if (basic_username && basic_pwd) {
						let credentials = btoa(basic_username + ":" + basic_pwd);
						this.headers.append('Authorization', `Basic ${credentials}`);
					}
				},
			}
		})
	}
}

export default strutCorsi;
